import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(16)};
`
const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: 100%;
`
const StyledDescription = styled(Paragraph)`
  margin-top: ${convertUnit(20)};
`

interface GiftShopTemplateModalMFAWarningProps {
  visible: boolean
  onCancel(): void
  onConfirm(): void
}
export default function GiftShopTemplateModalMFAWarning({
  visible,
  onCancel,
  onConfirm,
}: GiftShopTemplateModalMFAWarningProps) {
  const {translate} = useTranslation()
  return (
    <StyledModal visible={visible} onBackdropPress={onCancel}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {translate('giftShop:protectYourAccountTitle')}
      </StyledTitle>
      <Paragraph fontSize="l">
        {translate('giftShop:protectYourAccountDesc')}
      </Paragraph>
      <StyledDescription fontSize="m" color="gray_5">
        {translate('giftShop:protectYourAccountSubDesc')}
      </StyledDescription>
      <StyledButtonContainer>
        <StyledButton
          label={translate('global:later')}
          color="primary_5"
          backgroundColor="white_3"
          onClick={onCancel}
        />
        <StyledButton label={translate('global:setup')} onClick={onConfirm} />
      </StyledButtonContainer>
    </StyledModal>
  )
}
